module.exports = __webpack_public_path__ + "img/file-alt-light.7414c1fd.svg";